<template>
  <div class="footer">
    <p>
      megane<br>
      Senshu University School of Network and Information<br>
    </p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.footer{
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: lightgray;
  p{
    font-family: 'Roboto Condensed', sans-serif;
    font-weight: 700;
    text-align: center;
    color: white;
  }
}
</style>
